import { useEffect, useState } from 'react';
import { onSnapshot } from 'firebase/firestore';
import { tournamentDoc } from './tournaments';
import type { Tournament } from './types';

export function useTournament(id: string | undefined): {
  tournament: Tournament | null | undefined;
  error: Error | null;
} {
  const [tournament, setTournament] = useState<Tournament | null | undefined>(undefined);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    if (!id) {
      setTournament(null);
      return;
    }
    return onSnapshot(
      tournamentDoc(id),
      (snap) => setTournament(snap.exists() ? snap.data() : null),
      (err) => setError(err)
    );
  }, [id]);

  return { tournament, error };
}
